
export const enum AssetStatus {
    publish,
    unpublish
}

export class Asset {
  status:AssetStatus;
  content:any;
  type:string;
  options:any;

  constructor( status:AssetStatus, type:string, content:any, options?:any) {
    this.status = status;
    this.type = type;
    this.content = content;
    this.options = options;
  }
}
